module.exports = __webpack_public_path__ + "img/medium.2a331d01.svg";